/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_InsufficientInputs */

const cs_billing_insufficient = /** @type {(inputs: Billing_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedostatek AI kreditů. Dobijte nebo požádejte admina o alokaci.`)
};

const en_billing_insufficient = /** @type {(inputs: Billing_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough AI credits. Top up or ask an admin for allocation.`)
};

/**
* | output |
* | --- |
* | "Not enough AI credits. Top up or ask an admin for allocation." |
*
* @param {Billing_InsufficientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_insufficient = /** @type {((inputs?: Billing_InsufficientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_InsufficientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_insufficient(inputs)
	return cs_billing_insufficient(inputs)
});